import React, { useState, useMemo } from 'react';
import ButtonIcon from '../../../../button';
import { Selected_Index } from '../../../../../constants/external-constants';
import { ListTabButton } from '../../../../common/list-tab/list-tab-button.component';

import LocationFormView from '../locationsite-form/locationsite-form.component';
import LocationSiteComment from '../locationsite-comment/locationsite-comment.component';
import LocationSiteHistory from '../locationsite-history/locationsite-history.component';
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../../utils/helpers.utils";

const LocationsiteView = (props) => {
    const { locationId, closeFormAction, isCreateNew } = props;

    const [selectedIndex, setSelectedIndex] = useState("0");
    const [listTab] = useState([
        {
            id: Selected_Index.i_Zero,
            label: "Details",
            hidden: false
        },
        {
            id: Selected_Index.i_One,
            label: "Comments",
            hidden: false,
            disable: true
        },
        {
            id: Selected_Index.i_Two,
            label: "History",
            hidden: false,
            disable: true
        }
    ]);

    const FilterIndex = (index) => {
        setSelectedIndex(index);
    };

    const handleCloseForm = () => {
        closeFormAction();
    };

    const activeListTab = useMemo(() => {
        return listTab.map((item) => {
            let disabled = item.disable;
            if (
                (item.id === Selected_Index.i_One ||
                    item.id === Selected_Index.i_Two) &&
                locationId > 0
            ) {
                disabled = false;
            }

            return { ...item, disable: disabled };
        });
    }, [listTab, locationId]);

    const isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardR]);
    const isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardRE]);
    const isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardRW]);

    return (
        <div className="layout-container">
            <ButtonIcon
                onClick={handleCloseForm}
                iconLeft="chevron-left"
                iconSize="17px"
                customClassName="manage-invoice-back-button"
                labelName="Back"
            />

            {listTab && (
                <ListTabButton
                    listData={activeListTab}
                    selectedIndex={selectedIndex}
                    FilterIndex={FilterIndex}
                />
            )}

            <div>
                {selectedIndex === Selected_Index.i_Zero && (
                    <LocationFormView
                        isReadAndWrite={isReadAndWrite}
                        locationId={locationId}
                        isCreateNew={isCreateNew}
                        handleCloseForm={handleCloseForm}
                    />
                )}

                {selectedIndex === Selected_Index.i_One && (
                    <LocationSiteComment
                        locationId={locationId}
                        isReadOnly={isReadOnly}
                        isReadAndExtractOnly={isReadAndExtractOnly}
                        isReadAndWrite={isReadAndWrite}
                        isCreateNew={false}
                    />
                )}

                {selectedIndex === Selected_Index.i_Two && (
                    <LocationSiteHistory
                        locationId={locationId}
                        isReadOnly={isReadOnly}
                        isReadAndExtractOnly={isReadAndExtractOnly}
                        isReadAndWrite={isReadAndWrite}
                        isCreateNew={false}
                    />
                )}
            </div>
        </div>
    );
};

export default LocationsiteView;